import {
  UserX,
  ShieldCheck,
  CircleOff,
  MapPinOff,
  LucideIcon,
} from "lucide-react";
import { ExceptionType } from "../services/model/AttendanceException";

export type NewExceptionType =
  | "no_show"
  | "supervisor_clock"
  | "no_data"
  | "geofence";

export const NEW_EXCEPTION_TYPES: NewExceptionType[] = [
  "no_show",
  "supervisor_clock",
  "no_data",
  "geofence",
];

export const exceptionTypeLabels: Record<NewExceptionType, string> = {
  no_show: "No Show",
  supervisor_clock: "Supervisor Clock-In",
  no_data: "No Data",
  geofence: "Geofence Violation",
};

export const exceptionTypeIcons: Record<NewExceptionType, LucideIcon> = {
  no_show: UserX,
  supervisor_clock: ShieldCheck,
  no_data: CircleOff,
  geofence: MapPinOff,
};

export const exceptionTypeVariants: Record<
  NewExceptionType,
  "failed" | "processing" | "drafted"
> = {
  no_show: "failed",
  supervisor_clock: "processing",
  no_data: "drafted",
  geofence: "failed",
};

export const isNewExceptionType = (
  type: ExceptionType
): type is NewExceptionType =>
  (NEW_EXCEPTION_TYPES as ExceptionType[]).includes(type);
